import { render, staticRenderFns } from "./CampoApresentacao.vue?vue&type=template&id=14800029&scoped=true&"
import script from "./CampoApresentacao.vue?vue&type=script&lang=js&"
export * from "./CampoApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./CampoApresentacao.vue?vue&type=style&index=0&id=14800029&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14800029",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
